export default __webpack_public_path__ + "static/media/S_B_True.08701976.jpg";